export default {
  views: {
    privacy: {
      lastUpdated: '最后更新时间 2026年09月10日',
      companyName: 'Linktivity 株式会社',
      title: '隐私政策',
      personalInfoProtectionPolicy: '个人信息保护方针',
      personalInfoProtectionDescription:
        '本公司在本公司运营的预约网站 LINKTIVITY 等平台上向客户获取个人信息。本公司认为，为了让客户能够安心且便捷地完成预约，保护客户的个人信息是极为重要的事情，因此本公司遵守以下所载事项处理个人信息。',
      customerDataManager: '客户个人数据的管理者',
      companyAddress:
        '邮编 100-0011 东京都千代田区内幸町 2-1-6 日比谷 Park Front 19F',
      acquisition: '获取环节',
      acquisitionDescription:
        '在法令要求的情况下，本公司将在取得客户同意后，获取为达成本公司利用目的所必需的最低限度的个人信息。',
      usage: '使用环节',
      usageDescription:
        '本公司仅为达成本公司所规定的利用目的而使用从客户处获取的个人信息。',
      storage: '保管·保存环节',
      storageDescription:
        '本公司为避免从客户处获取的个人信息泄露至外部，在保管·保存个人信息等方面注重系统安全。',
      destruction: '销毁·删除环节',
      destructionDescription:
        '对于已无使用必要的个人数据（指日本《个人信息保护法》所规定的个人数据，以下相同），本公司将在无必要之时不迟延地予以销毁。',
      customerInquiry: '对客户咨询等的应对',
      customerInquiryDescription:
        '对于客户提出的持有个人数据（指日本《个人信息保护法》所规定的持有个人数据，以下相同）的利用目的告知要求、披露请求、更正·追加·删除请求、停止使用·删除请求以及停止向第三方提供的请求，本公司将依照法令予以应对。',
      safetyMeasures: '安全管理措施等',
      safetyMeasuresDescription:
        '本公司除对与 LINKTIVITY 服务相关的全体员工开展培训、使其理解个人信息的重要性外，还为个人信息的安全管理采取了必要且适当的措施。',
      tableOfContents: '目录',
      policy1: {
        title: '关于本公司获取的个人信息与利用目的',
        description:
          '本公司出于以下所列利用目的，获取并使用客户的住址、姓名、出生年月日、联系方式、电子邮件地址或护照号码等个人信息。此外，本公司不会在未取得客户同意的情况下获取需特别关照的个人信息。另外，在获取客户个人信息时，如个人信息的利用目的尚未公布，本公司将就该次获取的个人信息的利用目的向客户告知或予以公布。此外，本公司不会在未取得监护人同意的情况下向 13 周岁以下的儿童获取个人信息。在客户提供 13 周岁以下儿童的个人信息时，本公司将视为已取得监护人同意予以处理；但如明确未取得同意，本公司将不会把该个人信息用于联络监护人及其附随目的以外的其他目的。',
        serviceUsage: {
          title: '为使用 LINKTIVITY 服务（会员注册等）',
          description:
            '为使用 LINKTIVITY 服务，本公司将在公司内部共享客户的个人信息。',
          legalBasis: '为提供客户所要求的服务或功能所必需。'
        },
        ticketPurchase: {
          title: '为办理购票申请',
          infoItems:
            '在客户向商品提供方申请购票等情形下，本公司将获取客户的姓名、支付信息、护照号码，以及健康状况、病史等与客户健康状况相关的信息等。',
          purpose:
            '本公司为确认客户向商品提供方购票的资格以及结算票款等费用而获取并使用客户的个人信息。此外，出于上述目的，本公司将向商品提供方、交通机构、款项结算业者等（包括海外业者等）提供客户的个人信息。',
          legalBasis: '为提供客户所要求的服务或功能所必需。'
        },
        newsletter: {
          title: '为发送新闻通讯（电子邮件杂志等）等面向客户的通知',
          legalBasis: '基于客户的同意进行收集。'
        },
        advertising: {
          title: '为通过社交媒体及广告投放平台进行广告宣传',
          legalBasis: '基于客户的同意进行收集。'
        },
        survey: {
          title: '为请求客户填写问卷调查',
          legalBasis:
            '为改善本公司的预约网站、商品及服务等，基于客户的同意进行收集。'
        },
        analysis: {
          title: '为分析及管理客户信息',
          legalBasis:
            '通过改善本公司的预约网站、商品及服务等，为追求·保护客户的正当利益所必需。'
        },
        fraudDetection: {
          title: '为检测及防止信用卡等的欺诈使用',
          description1:
            '本公司出于检测及防止票券预约服务与会员注册服务中的欺诈购买、非法转售、冒充、欺诈支付、拒付（Chargeback）及其他不正当行为，以及提升服务安全性之目的，可能获取并使用以下信息。提供对象包括 Forter Inc. 以及本公司另行公布的防欺诈服务提供业者。',
          description2:
            '本公司提供的信息可能包括姓名、出生年月日、电子邮件地址、电话号码、住址、预约信息、购买历史、支付相关信息、IP 地址、Cookie 信息、浏览器信息、终端信息、访问日志以及其他为防止欺诈使用所必需的信息。',
          description3:
            '提供对象将分析这些信息，提供与交易相关的风险评估、欺诈使用判定、身份验证支持及其他防欺诈服务。',
          description4:
            '本公司将该业者提供的分析结果及判定结果用于预约受理、会员注册、身份验证、支付处理、防止欺诈使用及服务运营，并可能据此判断是否批准交易、暂缓交易或需要追加确认。',
          legalBasis:
            '通过防止欺诈使用及信用卡等的欺诈支付，为追求本公司与客户的正当利益所必需。'
        }
      },
      policy2: {
        title: '关于向第三方提供个人数据',
        description:
          '除以下任一情形外，本公司不会向第三方提供从客户处获取的个人数据。',
        case1:
          '就向第三方（包括商品提供方、海外旅行业者、社交媒体业者、广告投放服务公司等业者）提供个人数据，已通过同意本隐私政策的方式或其他方式事先取得客户同意的情形',
        case2:
          '在为达成上述利用目的所必需的范围内，将个人数据的处理委托给外部的情形',
        case3: '依据法令被要求提供的情形',
        case4: '为保护人的生命、身体或财产而有必要，且难以取得客户同意的情形',
        case5:
          '为提升公共卫生水平或促进儿童的健全成长而特别有必要，且难以取得客户同意的情形',
        case6:
          '国家或地方公共团体等在执行法令所规定的事务时有必要予以协助，且因取得客户同意而可能妨碍该事务执行的情形'
      },
      policy3: {
        title: '关于向位于外国的第三方提供个人数据',
        description1:
          '作为前条所规定的情形，本公司为检测及防止本服务中的欺诈交易，可能将客户的个人数据提供给位于外国的第三方。',
        description2:
          '本公司依照《个人信息保护法》及其他相关法令，在向客户提供有关向位于外国的第三方提供个人数据所必需的信息后，取得客户同意，或基于其他合法方式进行该项提供。',
        description3:
          '对于提供对象所在国的个人信息保护制度相关信息、该第三方所采取的个人信息保护措施以及其他法令上要求提供的信息，本公司将通过在本公司网站刊载或本公司认为适当的其他方式予以公布或提供。',
        description4:
          '为检测及防止本服务中的欺诈交易而从客户处获取、并提供给位于外国的第三方的数据项目等详情如下。',
        item1Label: '（1）提供的个人数据项目',
        item1Content:
          '在线交易信息（用户 ID、会员编号、姓名、电子邮件地址、电话号码、住址等）、设备信息（操作系统种类、语言、IP 地址、浏览器种类、位置信息、终端识别号码等）',
        item2Label: '（2）提供的手段或方法',
        item2Content:
          '电子方式（在线交易信息经哈希处理后，以不可读状态发送。）',
        item3Label: '（3）欺诈检测服务业者及其所在外国的名称等',
        companyNameLabel: '业者名称：',
        companyName: 'Forter, Inc.',
        countryLabel: '所在国家：',
        country: 'United States',
        addressLabel: '地址：',
        address: '575 5th Avenue, New York, United States (10017)',
        representativeLabel: '代表人：',
        representative: 'Michael Reitblat',
        item4Label: '（4）关于该外国的个人信息保护制度的信息',
        item4Content: '请通过以下个人信息保护委员会网站确认。',
        item5Label: '（5）欺诈检测服务运营业者所采取的个人信息保护措施',
        item5Content: '请通过以下 Forter 公司网页（隐私政策等）确认。',
        description5:
          '客户在会员注册或购票时同意本隐私政策的情况下，本公司可能视为客户亦已一并同意本项所规定的向位于外国的第三方提供个人数据。'
      },
      policy4: {
        title: '关于个人数据处理的委托',
        description:
          '本公司依据前项，在为达成本公司利用目的所必需的范围内将客户的个人数据处理委托给第三方时，将对受托方实施必要且适当的监督。此外，受托方进行再委托时，本公司将直接或间接监督受托方是否对再受托方实施了必要且适当的监督。再受托方进行再次委托的情形亦同。'
      },
      policy5: {
        title: '关于 Cookie 信息等的获取',
        cookie: {
          title: 'Cookie',
          description1:
            '本公司可能使用会话 Cookie 及其他 Cookie。Cookie 是存储于用户硬盘中、包含有关客户（用户）信息的一种数据。本公司不会将 Cookie 作为识别特定个人的信息加以使用。此外，会话 Cookie 在关闭浏览器后即被删除。',
          description2:
            'Cookie 用于提升面向客户的服务、对本公司网站进行个性化设置以及测定广告效果等目的。',
          description3:
            '此外，本公司通过将 Cookie 作为统计处理数据加以分析，探知客户所关注和感兴趣的事项并加以运用，同时也将其用于防止非法访问。',
          description4:
            '客户可以根据自身意愿停用 Cookie，但停用后客户将无法在 LINKTIVITY 上进行预约。此外，本公司出于防止欺诈使用及交易风险评估之目的，可能获取 Cookie、设备识别符及其他类似信息，并提供给防欺诈服务提供业者。'
        },
        logFile: {
          title: '日志文件',
          description1:
            '本公司会自动收集特定信息并保存至日志文件。该特定信息包括 IP（互联网协议）地址、浏览器类型、ISP（互联网服务提供商）、来源／退出页面、操作系统、日期／时间戳。本公司出于监控非法访问的目的使用这些信息。此外，本公司还会进行客户倾向分析、网站管理以及对客户在网站上的行为追踪。',
          description2:
            '但本公司在使用这些信息时会使其无法识别特定个人，且不会将所获取的信息用于上述以外的目的。本公司为防止欺诈使用及提升安全性，可能获取 IP 地址、浏览器信息、终端识别信息、访问日志及其他在线识别信息，并提供给防欺诈服务提供业者。'
        },
        webBeacon: {
          title: '关于网络信标',
          description:
            '本公司将网络信标用于访问分析及联盟营销（Affiliate）计划。本公司不会将网络信标用于上述以外的目的，也不会用于识别特定个人。'
        },
        statisticalAnalysis: {
          title: '关于统计分析',
          description1:
            '为确认哪些网站或服务更受欢迎，本公司会使用第三方访问分析工具，记录客户在 LINKTIVITY 网站内访问的页面及页面浏览历史。',
          description2:
            '本公司使用这些数据，以便在 LINKTIVITY 内向对特定领域表现出兴趣的客户提供符合其兴趣的内容和广告。',
          description3:
            '此外，本公司也可能收集不识别个人的统计信息。并且，本公司还可能在第三方访问分析工具上使本公司收集的 Cookie 信息与其他公司收集的 Cookie 信息可供双方查阅。'
        }
      },
      policy6: {
        title: '关于匿名加工信息的处理',
        creation: {
          title: '匿名加工信息的制作',
          description1:
            '本公司在制作匿名加工信息时，将采取以下措施。匿名加工信息，是指采取法令所规定的措施对个人信息进行加工，使其无法识别特定个人而获得的有关个人的信息，且已使该个人信息无法复原者。',
          description2:
            '①依照法令规定的标准适当地进行加工；②依照法令规定的标准，为防止已删除的信息及有关加工方法的信息泄露而采取安全管理措施；③公布所制作的匿名加工信息中所含信息的项目；④不实施为识别制作时所使用个人信息之本人的行为'
        },
        provision: {
          title: '匿名加工信息的提供',
          description:
            '向第三方提供匿名加工信息时，本公司将公布拟提供的匿名加工信息中所含有关个人的信息项目及提供方法，同时向作为接收方的第三方明示所提供的信息为匿名加工信息。'
        },
        disclosure: {
          title: '关于匿名加工信息的公布',
          creationSubtitle: '关于匿名加工信息的制作',
          creationDescription:
            '对于本公司持有的以下客户个人信息，本公司在采取适当措施使其无法识别特定个人且无法复原个人信息后，将持续制作为匿名加工信息。',
          itemsTitle: '匿名加工信息中所含有关个人的信息项目',
          itemsDescription:
            '与平台服务提供相关而获取的信息——购买日、参加日、凭证（Voucher）语言、销售金额区间、参加人数、预约状态（预约确定或取消等）、供应商所在地区及县信息、旅行社所在国家',
          thirdPartyTitle: '关于向第三方提供匿名加工信息',
          thirdPartyDescription:
            '对于本公司制作或持有的匿名加工信息，本公司将在明示该信息为匿名加工信息后，持续向第三方提供。',
          provisionMethod:
            '通过电子通信方式（电子邮件、上传至服务器、API 对接等）或 DVD 等物理介质发送以密码保护的电子文件'
        }
      },
      policy7: {
        title: '关于个人数据的安全管理措施',
        description1:
          '为防止个人数据泄露、盗用、滥用、非法访问、篡改及破坏等，本公司采取了组织性、技术性、物理性的安全管理措施。对本公司存储个人数据的服务器的访问，仅限于持有 ID／密码的特定员工；其中对部分个人数据的管理，仅向数据管理等工作所需的最低限度员工授予访问权限。',
        description2:
          '此外，对于包含信用卡信息的个人数据，本公司分散存放于多个数据中心并保管于安全环境之中。并且，本公司在所有与预约交易相关的页面上均使用 Secure Sockets Layer（SSL）加密。通过使用支持 SSL 的浏览器，可以保持在互联网上传输的个人数据与信用卡信息的机密性。',
        description3:
          '此外，本公司处理客户个人数据的员工在离开终端时会使用以密码保护的屏幕保护程序。',
        description4:
          '进一步地，本公司按部门每月一次、全公司范围内每半年至少一次的频率，实施有关个人信息重要性等的教育培训。此外，本公司也会保留有关培训的记录。'
      },
      policy8: {
        title: '关于客户个人数据处理的相关权利',
        description:
          '根据 2016 年 4 月 27 日的欧盟《通用数据保护条例》（GDPR）2016/679，就个人数据的处理，客户享有以下权利。',
        right1: '访问权',
        right2: '更正权',
        right3: '删除权（被遗忘权）与限制处理的权利',
        right4: '数据可携带权',
        right5: '提出异议的权利',
        right6:
          '不受包含用户画像（Profiling）在内的自动化处理所作决定约束的权利。'
      },
      policy9: {
        title: '关于披露·更正·停止使用等请求',
        description1:
          '对于客户提出的持有个人数据的利用目的告知要求、披露请求、更正·追加·删除请求、停止使用·删除请求或停止向第三方提供的请求（以下统称为「披露等请求」），本公司将通过下述第 12 项所载的联系窗口予以应对。',
        description2:
          '此外，本公司将通过客户的「我的页面」，响应变更及确认会员信息、停止接收电子邮件杂志等需求。'
      },
      policy10: {
        title: '关于外部链接',
        description:
          'LINKTIVITY 主页中包含指向其他网站的链接。本隐私政策仅适用于通过 LINKTIVITY 主页收集的信息，对于其他网站的隐私政策或内容，本公司不承担责任。恳请客户在各链接目标网站上阅读其隐私政策，确认自身个人信息的处理方式。'
      },
      policy11: {
        title: '关于隐私政策的变更',
        description:
          '本公司将隐私政策刊载于 LINKTIVITY 主页，使客户能够随时了解本公司获取并使用客户何种个人信息、用于何种目的。此外，隐私政策的变更亦刊载于 LINKTIVITY 主页，向客户予以公布。'
      },
      policy12: {
        title: '关于联系方式',
        description1:
          '关于本公司的隐私政策、本公司在个人信息保护方面的举措、客户个人信息的获取与使用等问题，或披露等请求，请使用以下咨询表单。负责人员将在 5 个工作日内予以回复。',
        company: 'Linktivity 株式会社',
        address:
          '邮编 100-0011 东京都千代田区内幸町 2-1-6 日比谷 Park Front 19F',
        dpoContact: '数据保护负责人联系方式: dpo@linktivity.co.jp'
      },
      contentLabels: {
        acquisitionOfPersonalInfo: '取得的个人信息项目',
        specificPurpose: '具体的利用目的',
        legalBasis: '法律依据：',
        provisionMethod: '提供的方法'
      }
    },
    product: {
      plans: {
        title: '选择套餐'
      },
      cancelPolicy: {
        title: '取消政策'
      },
      recommendations: {
        title: '其他推荐'
      },
      panels: {
        selectDate: '选择日期',
        selectPlan: '选择套餐',
        selectPeople: '选择人数',
        options: '附加商品',
        profile: '个人资料'
      },
      auth: {
        loginOrRegister: '登录 / 注册'
      }
    },
    book: {
      title: '订单确认',
      bookingNotice: '请在预订前确认',
      paymentConfirmation: '请在支付前确认',
      tip: '为确认订单，请在15分钟内完成操作',
      sessionInfo: '预订信息'
    },
    bookConfirm: {
      productInfo: '商品信息',
      sessionConfirmed: '已确认',
      sessionUnconfirmed: '未确认',
      paymentInfo: '支付信息',
      paymentConfirmation: {
        warningTitle: '请确认取消政策：',
        warningText: '该商品一旦购买将无法退款。',
        agreementText: '我已确认并同意'
      },
      prePaymentConfirmation: {
        title: '支付前确认事项',
        checkInput: '请确认输入内容是否正确。',
        emailNotice:
          '注意：如果您设置了域名邮件过滤，请在预约前将"@linktivity.co.jp"添加到白名单。',
        agreementText: '我已确认并同意上述事项。'
      },
      paymentAmount: {
        total: '支付金额（含税）',
        details: '详细',
        note: '日元以外的币种金额为依据当前汇率计算的预估金额，与实际扣款金额可能略有差异，仅供参考。'
      },
      confirmPaymentDialogTitle: '付款确认',
      participantInfo: {
        title: '参与者信息',
        dialogTitle: '修改参与者信息',
        change: '变更',
        password: '密码',
        validation: {
          passwordRequired: '请输入密码'
        }
      },
      couponApplied: '优惠券已成功使用',
      couponFailed: '优惠券使用失败',
      couponRemoved: '优惠券已成功移除',
      couponRemoveFailed: '优惠券移除失败',
      actionButtons: {
        back: '返回',
        toPayment: '去支付'
      }
    },
    voucher: {
      pdf: '打印用PDF',
      html: '凭证'
    },
    bookingDetail: {
      title: '预订详情',
      detailInfo: '预订详情',
      startDate: '参加日期',
      validityPeriod: '有效期',
      voucherInfo: '凭证',
      digitalTicket: '电子票',
      invoice: '收据/发票',
      invoiceSend: '开具',
      invoiceSent: '发票已开具',
      redemption: '使用电子票',
      meetingPoint: '入场位置指南',
      beforeTrip: '使用前确认事项',
      bookingAction: '预订操作',
      cancelBooking: '取消预订',
      cancelConfirmPolicy: '请确认取消政策：',
      customerName: '预订人',
      actualPayment: '支付金额',
      refundAmount: '退款金额',
      orderId: '预订ID',
      orderCompletionTime: '预订时间',
      digitalTicketValidPeriod: 'QR码仅在使用当天有效',
      digitalTicketWaiting: '*订单确认后，电子票将在此显示',
      sending: '发送中...',
      sendToEmail: '发送至邮箱',
      cancelConfirm: '是否确认取消预订？',
      cancelFee: '取消费用',
      cancelRemarkSelect: '请选择取消原因',
      inclusion: '包含的物品',
      checklist: '注意事项',
      restrictions: '参加制限',
      requirements: '参加前・参加时必要事项',
      attireItems: '参加时必要服装・持物',
      otherInfo: '备注・其他',
      attachmentType: {
        ATTACHMENT_TYPE_PDF: 'PDF',
        ATTACHMENT_TYPE_IMAGE: '图片'
      }
    },
    cancelReason: {
      CANCEL_REASON_OTHER: '其他',
      CANCEL_REASON_MODIFY_BOOKING: '变更预订日期或人数',
      CANCEL_REASON_BOOKED_BY_MISTAKE: '误订',
      CANCEL_REASON_DUPLICATE_BOOKING: '因重复预订',
      CANCEL_REASON_HEALTH_CONDITION: '生病',
      CANCEL_REASON_TRANSPORTATION_ISSUE: '航班取消、延误或变更',
      CANCEL_REASON_SCHEDULE_CONFLICT: '行程有变',
      CANCEL_REASON_CHANGE_TO_OTHER_PRODUCT: '改订为其他商品'
    },
    common: {
      withDashSeparated: '{{val1}} - {{val2}}'
    },
    home: {
      title: 'SHIBUYA SKY',
      header: {
        alt: 'SHIBUYA SKY'
      },
      search: {
        placeholder: '搜索商品'
      },
      ticketList: {
        title: '票券一览'
      },
      enjoyPack: {
        title: '畅游套餐'
      }
    },
    faq: {
      tips: `如您对本 FAQ 中的内容（如在线购票、取消、开具收据等）有任何疑问，请联系 LINKTIVITY 客户服务中心。
如您对 SHIBUYA SKY 的设施、服务等有任何疑问，请通过 SHIBUYA SKY 官方网站的咨询页面进行咨询。
https://www.shibuya-scramble-square.com/sky/contact/

LINKTIVITY 客户服务中心
电子邮箱：<a href="mailto:helpcenter@linktivity.co.jp" rel="noreferrer">helpcenter@linktivity.co.jp</a>
在线购票相关咨询电话：<a href="tel:+81368217193">03-6821-7193</a>
※来电后将先由自动语音系统为您提供引导，之后会根据您的咨询内容转接至客服人员。
※电话咨询将产生通话费用。
客服人员服务时间：10:00～19:00`
    }
  }
};
